/**
 *  Missile
 *
 *  Created by Legman on 20/04/2017.
 *
 */

import Common       from "../Common";
import RaceMover    from "../race/RaceMover";

/**
 * @class
 * @extends RaceMover
 */
export default class Missile extends RaceMover {
    /**
     * @param {RaceCar} owner
     */
    constructor(owner) {
        const temp = new PIXI.Sprite(Common.assets.getTexture("powerup_missile_normal_object_01"));
        temp.anchor = new PIXI.Point(0.5, 0.5);
        temp.tint = 0xFF0000;
        super(temp);

        this.acceleration = 16;
        this.velocity = this.acceleration;
        this.linearDamping = 0.994;
        this.collisionWidth = 60;
        this.collisionLength = 60;

        /**
         * @type {number}
         */
        this.powerupType = 0;

        /**
         * @member {number}
         */
        this.life = 40;

        /**
         * @member {RaceCar}
         * @protected
         */
        this._owner = owner;

        /**
         * @member {number}
         * @protected
         */
        this._startDist = 0;

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        this._trailEmitter = null;

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        this._explosionEmitter = null;

        /**
         * @type {boolean}
         * @private
         */
        this._armed = true;
    }

    /**
     */
    init() {
        this._startDist = this.getTotalDistance();

        this._createTrailEmitter();
    }

    /**
     */
    destroy() {
        this._trailEmitter.destroy();

        super.destroy();
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        if (this._armed) {
            super.update(dt);
            const distance = this.getTotalDistance() - this._startDist;
            if (distance > this.life) {
                this.explode();
            }
        }

        this._trailEmitter && this._trailEmitter.update(dt);
        this._explosionEmitter && this._explosionEmitter.update(dt);
        if (this._explosionEmitter && !this._explosionEmitter.emit) {
            this.destroyNextFrame = true;
        }
    }

    explode() {
        this._armed = false;

        this._createExplosionEmitter();
        this._explosionEmitter.playOnceAndDestroy();

        this._view.visible && Common.audio.playSound(["sfx_bomb_explode_big_00", "sfx_bomb_explode_big_01"]);
    }

    /**
     * @protected
     */
    _createTrailEmitter() {
        const assets = Common.assets;
        const config = assets.getJSON("particle_emitter_missile_normal_trail");

        const holder = new PIXI.Container();
        holder.scale = new PIXI.Point(2, 2);
        this._view.addChild(holder);

        this._trailEmitter = new PIXI.particles.Emitter(this._view, [
            assets.getTexture("particles_rockettrail_00"),
            assets.getTexture("particles_rockettrail_01"),
            assets.getTexture("particles_rockettrail_02"),
            assets.getTexture("particles_rockettrail_03")
        ], config);
        this._trailEmitter.emit = true;
    }

    /**
     * @protected
     */
    _createExplosionEmitter() {
        const assets = Common.assets;
        const config = assets.getJSON("particle_emitter_explosion_00");

        const holder = new PIXI.Container();
        holder.scale = new PIXI.Point(2, 2);
        this._view.addChild(holder);

        this._explosionEmitter = new PIXI.particles.Emitter(holder, [
            assets.getTexture("particle_explosion_smoke_00"),
            assets.getTexture("particle_explosion_smoke_01"),
            assets.getTexture("particle_explosion_smoke_02")
        ], config);
        this._explosionEmitter.emit = false;
    }

    /**
     * @returns {RaceCar}
     */
    get owner() {
        return this._owner;
    }

    /**
     * @returns {boolean}
     */
    get armed() {
        return this._armed;
    }
}